export default {
      id: "icon-logo-inverted-usage",
      viewBox: "0 0 215.5 143.46",
      url: __webpack_public_path__ + "img/icons.svg#icon-logo-inverted",
      toString: function () {
        return this.url;
      }
    }